// extracted by css-extract-rspack-plugin
export default {"callout":"callout-saO9J1 text-sm","calloutAction":"calloutAction-cynF1q"};